export default Object.freeze({
  TempPressure: 'Filter',
  A2TempPressure: 'Filter',
  Temp: 'Comfort',
  A2TempHumidity: 'Comfort',
  WaterLeak: 'Water',
  A2WaterLeak: 'Water',
  GW_TempHumidity: 'Hub',
});
